import Vue from 'vue';
import store from './../../store';
import subscriberListTransformer from './../../transformers/subscriberList';
import paginationTransformer from '../../transformers/pagination';

const success = ({ data }, resolve) => {
  const subscriberList = subscriberListTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
  store.dispatch('fetchPaginatedSubscriberList', { subscriberList, pagination });
  resolve(data);
};

const failed = (error, reject) => reject(error);


export default (page = 1, limit = 10) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`subscriberList?page=${page}&limit=${limit}`)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/subscriberList/items.js